import React, { useState, useEffect } from 'react';
import portfolioAPI from '../services/portfolioAPI.js';
import './About.css';

const About = () => {
  const [personalInfo, setPersonalInfo] = useState(null);
  const [certifications, setCertifications] = useState([]);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedCertificate, setSelectedCertificate] = useState(null);
  const [error, setError] = useState(null);
  const [activeFilter, setActiveFilter] = useState('All');

  const certificationFilters = ['All', 'Programming', 'Platform', 'Internship', 'Others'];

  const normalizeType = (raw) => {
    if (!raw) return 'Others';
    const t = String(raw).toLowerCase().trim();
    if (t.includes('program')) return 'Programming';
    if (t.includes('intern')) return 'Internship';
    if (t.includes('platform')) return 'Platform';
    if (t.includes('professional')) return 'Platform';
    if (t.includes('tech')) return 'Platform';
    if (t.includes('web')) return 'Platform';
    // default fallback
    return 'Others';
  };

  // Prefer title-based overrides for specific certificates
  const normalizeCertType = (cert) => {
    if (!cert) return 'Others';
    const title = (cert.title || '').toLowerCase();
    // If title indicates an internship, prefer Internship
    if (title.includes('intern') || title.includes('internship')) return 'Internship';
    // Explicit rules requested: Software Job Simulation => Internship
    if (title.includes('software job')) return 'Internship';
    // IoT cert should be Others
    if (title.includes('iot')) return 'Others';
    // Machine learning should be Programming (check full words first)
    if (title.includes('machine learning') || title.includes('machine-learning') || /\bml\b/.test(title)) return 'Programming';
    // fall back to type field
    return normalizeType(cert.type);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const [info, certs, portfolioStats] = await Promise.all([
          portfolioAPI.getPersonalInfo().catch(err => {
            console.log('Personal info API failed, using fallback');
            return {
              name: "Sai Kowshik Suggala",
              specialization: "Computer Science Engineering",
              title: "",
              description: "Passionate B.Tech Student specializing in full-stack development, creating innovative solutions with modern web technologies and proficiency in data structures."
            };
          }),
          portfolioAPI.getCertifications().catch(err => {
            console.log('Certifications API failed, using fallback');
            return [
              { title: "Google AI-ML Virtual Internship", issuer: "Eduskills", year: "2025", type: "Internship", credential_url: "https://drive.google.com/file/d/11W1mQibXnGE3CKlGsKkyc0fTeV5rfNct/view?usp=drive_link" },
              { title: "Java Programming", issuer: "NPTEL", year: "2025", type: "Programming", credential_url: "https://drive.google.com/file/d/1bSQrfObQeYpDJEv8PIBarJwAA3CIJ_R3/view?usp=drive_link" },
              { title: "1M1B Green Internship", issuer: "1M1B", year: "2025", type: "Internship", credential_url: "https://drive.google.com/file/d/1nDCUlkB3AW-YIheJ5MADHV79JvgkKjJG/view?usp=drive_link" },
              { title: "Python Programming", issuer: "NPTEL", year: "2024", type: "Programming", credential_url: "https://drive.google.com/file/d/1UCMsfpO5fYENjsby4P0TRuplp1YDdCXB/view?usp=drive_link" },
              { title: "Hp AI Life", issuer: "HP", year: "2025", type: "Others", credential_url: "https://drive.google.com/file/d/1AlSTu0K8YoZC8DCvCL0Ma7SEwMAU4p0d/view?usp=drive_link" },
              { title: "IoT Technologies", issuer: "NPTEL", year: "2025", type: "Others", credential_url: "https://drive.google.com/file/d/1VHZ0Vrm1YZxoEZ9acgMY374MylSdDaTl/view?usp=drive_link" },
              { title: "Software Job Simulation", issuer: "Forage", year: "2025", type: "Internship", credential_url: "https://drive.google.com/file/d/1RCaWJ_ULBSidthePWzlRTJRrFdU9_HVa/view?usp=drive_link" },
              { title: "Machine Learning from Columbia University", issuer: "Columbia University", year: "2025", type: "Programming", credential_url: "https://drive.google.com/file/d/181lPlwWFypTK2Io8_ZhmEQ2XI2CjLqHn/view?usp=drive_link" },
              { title: "Oracle Cloud Foundations", issuer: "Oracle", year: "2025", type: "Platform", credential_url: "https://drive.google.com/file/d/1_XuG-jVJCb6rqxueQ90QwxpR3JOVa-sa/view?usp=drive_link" },
              { title: "AWS Cloud Foundations", issuer: "AWS Educate", year: "2025", type: "Platform", credential_url: "https://drive.google.com/file/d/12sTjZNHYWzOyDT_VrklUlourRCwpPomB/view?usp=drive_link" },
              { title: "Micro Certification", issuer: "Service Now", year: "2025", type: "Platform", credential_url: "https://drive.google.com/file/d/161vplKOuxFxJ04kMRngx8L7wsPkR7-wm/view?usp=drive_link" },
              { title: "Software Project Management", issuer: "NPTEL", year: "2025", type: "Others", credential_url: "https://drive.google.com/file/d/1O8_wV1nwtNc05KFWol-XFbKN9K9YMQ9E/view?usp=drive_link" },
              { title: "IBM Frontend", issuer: "Eduskills", year: "2025", type: "Internship", credential_url: "https://drive.google.com/file/d/1IzKj-0N6EgaqTbLVaANS5G1_jpnzxNyI/view?usp=drive_link" },
              { title: "SQL and Database Management Systems Internship", issuer: "Eduskills", year: "2026", type: "Internship", credential_url: "https://drive.google.com/file/d/1wOvjbF6bOYsj0matK74C04nlGso4R8-V/view?usp=drive_link" },
              { title: "Oracle Agentic AI Foundations Associate", issuer: "Oracle", year: "2026", type: "Platform", credential_url: "https://drive.google.com/file/d/1BdtiEUTfVu_hgYa4h9G2EcnsuXGSrbXS/view?usp=drive_link" },
            ];
          }),
          portfolioAPI.getPortfolioStats().catch(err => {
            console.log('Stats API failed, using fallback');
            return { total_projects: 6, total_certifications: 11 };
          })
        ]);
        
        // Deduplicate certifications by id when available, otherwise fallback to title+issuer+year
        const seen = new Set();
        const deduped = (certs || []).filter((c) => {
          const idKey = c?.id || c?._id || null;
          const fallbackKey = `${(c.title||'').trim().toLowerCase()}||${(c.issuer||'').trim().toLowerCase()}||${(c.year||'').toString()}`;
          const key = idKey ? `id::${String(idKey)}` : `fk::${fallbackKey}`;
          if (seen.has(key)) return false;
          seen.add(key);
          return true;
        });

        // Sort by year (desc) then title so new certifications appear first
        deduped.sort((a, b) => {
          const ay = parseInt(a.year || '0') || 0;
          const by = parseInt(b.year || '0') || 0;
          if (by !== ay) return by - ay;
          const at = (a.title || '').toLowerCase();
          const bt = (b.title || '').toLowerCase();
          return at < bt ? -1 : at > bt ? 1 : 0;
        });

        setPersonalInfo(info);
        setCertifications(deduped);
        setStats(portfolioStats);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching about data:', error);
        setError('Failed to load data');
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleCertificateClick = (cert) => {
    console.log('Certificate clicked:', cert);
    setSelectedCertificate(cert);
  };

  const closeCertificate = () => {
    setSelectedCertificate(null);
  };

  const handleFilterChange = (filter) => {
    setActiveFilter(filter);
  };

  const getFilteredCertifications = () => {
    if (activeFilter === 'All') {
      return certifications;
    }
    return certifications.filter(cert => normalizeCertType(cert) === activeFilter);
  };

  if (loading) {
    return (
      <section id="about" className="about-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">About Me</h2>
            <div className="title-underline"></div>
          </div>
          <div className="loading-container">
            <div className="loading-spinner"></div>
            <p>Loading about information...</p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="about" className="about-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">About Me</h2>
          <div className="title-underline"></div>
        </div>
        <div className="about-content">
          <div className="about-text">
            <p className="about-intro">
              I'm a passionate {personalInfo?.specialization || "Computer Science Engineering"} student with a strong foundation in 
              full-stack development and data structures. My journey in technology has been driven by curiosity and 
              a desire to create meaningful solutions that make a difference.
            </p>
            <div className="about-stats">
              <div className="stat-item">
                <h3>{stats?.total_projects || 0}+</h3>
                <p>Projects Completed</p>
              </div>
              <div className="stat-item">
                <h3>{stats?.total_certifications || 0}+</h3>
                <p>Certifications</p>
              </div>
            </div>
          </div>
          <div className="about-visual">
            <div className="profile-card">
              <div className="card-background"></div>
              <div className="card-content">
                <div className="certifications">
                  <h4 className="certifications-title"><strong>Certifications</strong></h4>
                  <div className="certification-filters">
                    {certificationFilters.map((filter, index) => (
                      <button
                        key={index}
                        className={`filter-toggle ${activeFilter === filter ? 'active' : ''}`}
                        onClick={() => handleFilterChange(filter)}
                      >
                        {filter}
                      </button>
                    ))}
                  </div>
                  <div className="certifications-scroll">
                    {getFilteredCertifications().map((cert, index) => (
                      <div 
                        key={index} 
                        className="certification-box"
                        onClick={() => handleCertificateClick(cert)}
                      >
                        <h5>{cert.title}</h5>
                        <p>{cert.issuer} • {cert.year}</p>
                        <span className="cert-type">{normalizeCertType(cert)}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Certificate Modal */}
      {selectedCertificate && (
        <div className="certificate-modal" onClick={closeCertificate}>
          <div className="certificate-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-button" onClick={closeCertificate}>×</button>
            <div className="certificate-details">
              <h3>{selectedCertificate.title}</h3>
              <p><strong>Issuer:</strong> {selectedCertificate.issuer}</p>
              <p><strong>Year:</strong> {selectedCertificate.year}</p>
              <p><strong>Type:</strong> {selectedCertificate.type}</p>
              {
                // normalize possible URL keys and trim whitespace
                (() => {
                  const rawUrl =
                    selectedCertificate?.credential_url ||
                    selectedCertificate?.credentialUrl ||
                    selectedCertificate?.url ||
                    selectedCertificate?.link ||
                    '';
                  const certUrl = rawUrl ? String(rawUrl).trim() : '';
                  return certUrl ? (
                    <>
                      <p>
                        <a
                          href={certUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="certificate-link"
                        >
                          Click to view
                        </a>
                      </p>
                      
                    </>
                  ) : null;
                })()
              }
              {(!selectedCertificate?.credential_url && !selectedCertificate?.credentialUrl && !selectedCertificate?.url && !selectedCertificate?.link) && (
                <div className="certificate-placeholder">
                  <div className="certificate-icon">🏆</div>
                  <p>Certificate details for {selectedCertificate.title}</p>
                  <small>This is a mock certificate view</small>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default About;